import { useCmsPage } from "@/hooks/useCms";
import useContactForm from "@/hooks/useContactForm";

import LoadingScreen from "@/components/LoadingScreen";
import SoftwareContactPage from "@/components/cms/SoftwareContactPage";
import ContactForm from "@/components/cms/ContactForm";

export default function ContactPage() {
  const { page, loading } = useCmsPage("contact");

  const {
    form,
    change,
    submit,
    submitting,
    done,
  } = useContactForm();

  if (loading) return <LoadingScreen />;
  if (!page) return null;

  return (
    <SoftwareContactPage page={page} done={done}>
      <ContactForm
        page={page}
        form={form}
        change={change}
        submit={submit}
        submitting={submitting}
        done={done}
      />
    </SoftwareContactPage>
  );
}